import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthUserModel, HxAuthService } from 'hx-services';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NzPageHeaderComponent, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { KeyValuePipe, NgFor } from '@angular/common';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.less'],
  imports: [TranslocoDirective, NzPageHeaderComponent, NzPageHeaderTitleDirective, FormsModule, NzFormDirective, ReactiveFormsModule, NzAlertComponent, NzRowDirective, NzFormItemComponent, NzColDirective, NzFormLabelComponent, NzFormControlComponent, NzInputDirective, NgFor, NzButtonComponent, NzWaveDirective, KeyValuePipe, TranslocoPipe]
})
export class PasswordChangeComponent implements OnInit, OnDestroy {

  @Input() user!: AuthUserModel;
  @Output() passwordChange = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();
  isLoading = {
    save: false,
  };
  form!: UntypedFormGroup;
  errorMessageMap = new Map<string, string>();
  private $destroyed = new Subject<void>();

  constructor(
    private fb: UntypedFormBuilder,
    private auth: HxAuthService,
    private nt: NzNotificationService,
    private tr: TranslocoService,
  ) {
  }

  ngOnInit() {
    const passwordControl = this.fb.control(null, Validators.required);
    const confirmControl = this.fb.control(null, Validators.required);
    this.form = this.fb.group({
      password: passwordControl,
      passwordConfirmation: confirmControl,
    });
    const passwordNotEqualKey = 'profile.error.passwordNotEqual';
    this.form.valueChanges.pipe(debounceTime(500), takeUntil(this.$destroyed)).subscribe(val => {
      console.log('val', val);
      this.errorMessageMap.delete(passwordNotEqualKey);
      if (confirmControl.value && passwordControl.value !== confirmControl.value) {
        this.errorMessageMap.set(passwordNotEqualKey, this.tr.translate(passwordNotEqualKey));
      }
    });
  }

  savePassword() {
    if (this.form.controls['password'].value !== this.form.controls['passwordConfirmation'].value) {
      return;
    }
    // eslint-disable-next-line guard-for-in
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.valid) {
      this.isLoading.save = true;
      this.auth.updatePassword(this.form.controls['password'].value).subscribe(() => {
        this.nt.success(this.tr.translate('result.saved'), this.tr.translate('profile.result.passwordChanged'));
        this.isLoading.save = false;
        this.errorMessageMap.clear();
      }, err => {
        console.error('err', err);
        if (err.error?.message) {
          this.errorMessageMap.set(err.error.message, this.tr.translate(`error.${err.error.message}`, err.error.data));
        } else {
          this.errorMessageMap.set('unexpected', this.tr.translate('error.unexpected'));
        }
        this.isLoading.save = false;
      });
    }
  }

  onBackClicked() {
    this.form.reset();
    this.back.emit();
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }
}
